import { render } from "./ModelResults.vue?vue&type=template&id=8b503010&scoped=true"
import script from "./ModelResults.vue?vue&type=script&lang=js"
export * from "./ModelResults.vue?vue&type=script&lang=js"

import "./ModelResults.vue?vue&type=style&index=0&id=8b503010&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b503010"]])

export default __exports__